import FileUploadOverlay from './FileUploadOverlay';

export default FileUploadOverlay;
